import { ValidateStep } from 'utils/Validations';
// import { ValidateStep } from 'utils/Validations'

import { submitForm, ICheckoutForm } from 'utils/submitForm'

interface ISelectedItems {
  shipping: boolean
  payment: boolean
}

const Checkout = {
  el: {
    root: document.querySelector<HTMLElement>('.checkout'),

    deliveryType: document.querySelectorAll<HTMLInputElement>('[name=ShippingProvider]'),
    paymentType: document.querySelectorAll<HTMLInputElement>('[name=PaymentProvider]'),
    detailsForm: document.querySelector<HTMLFormElement>('.checkout__details-form'),
    // shippingForm: document.querySelector<HTMLFormElement>('.checkout__shipping-form'),
    paymentForm: document.querySelector<HTMLFormElement>('.checkout__payment-form'),
    message: document.querySelector<HTMLFormElement>('.checkout__message'),
    submitButton: document.querySelector<HTMLButtonElement>('.checkout__submit'),
    shippingCheckbox: document.querySelector<HTMLInputElement>('.checkout__shipping-information-check input'),
    shippingInfo: document.querySelector<HTMLInputElement>('.checkout__step-section[data-type="shipping"]'),
  },

  init() {
    if (this.el.root) {
      const redirect = this.el.root.dataset.redirect

      if (this.el.detailsForm) {
        this.handleForms(this.el.detailsForm, null, redirect)
      }

      // if (this.el.shippingForm) {
      //   this.handleForms(this.el.shippingForm, this.el.deliveryType)
      // }

      if (this.el.paymentForm) {
        this.handleForms(this.el.paymentForm, this.el.paymentType)
      }

      this.handleSubmitButton()
      this.handleMessage()
      this.handleShippingInformationCheckbox()
    }
  },

  handleShippingInformationCheckbox() {
    this.el.shippingCheckbox?.addEventListener('change', (e: Event & { target: HTMLInputElement }) => {
      this.el.shippingInfo.classList.toggle('hide')

      if (e.target.checked) {
        this.el.shippingInfo.querySelectorAll('input').forEach((input) => {
          input.value = ''
          input.removeAttribute('required')
        })
      } else {
        this.el.shippingInfo.querySelectorAll('input').forEach((input) => {
          input.setAttribute('required', '')
        })
      }
    })
  },

  handleMessage(): void {
    if (this.el.message) {
      if (this.el.message.style.display === 'flex') {

        setTimeout(() => {
          this.el.message.style.display = 'none'
        }, 10000);
      }
    }
  },

  handleSubmitButton() {
    if (this.checkForSelected().shipping && this.checkForSelected().payment) {
      if (this.el.submitButton) {
        this.el.submitButton.removeAttribute('disabled')
      }
    }
  },

  handleForms(form: HTMLFormElement, items: NodeListOf<HTMLInputElement>, redirect: string = ''): void {
    if (form) {
      form.addEventListener('submit', e => {
        e.preventDefault()
        if (ValidateStep(form)) {
          submitForm(form).then((s: ICheckoutForm) => {
            if (s.success) {
              if (redirect) {
                window.location.href = redirect
              }
              else {
                window.location.reload()
              }
            }
            else {
              alert('halloo')
            }
          }).catch(err => {
            console.log('handleForms error', err)
          })
        }
      })
    }

    // if (items) {
    //   Array.prototype.forEach.call(items, item => {
    //     item.addEventListener('change', e => {
    //       e.preventDefault();
    //       console.log('changeit');

    //       // form.requestSubmit()
    //     })
    //   })
    // }
  },

  checkForSelected(): ISelectedItems {
    let hasDelivery = false;
    let hasPayment = false;

    if (this.el.deliveryType) {
      Array.prototype.forEach.call(this.el.deliveryType, (item: HTMLInputElement) => {
        if (item.checked) {
          hasDelivery = true;
        }
      })
    }

    if (this.el.paymentType) {
      Array.prototype.forEach.call(this.el.paymentType, (item: HTMLInputElement) => {
        if (item.checked) {
          hasPayment = true;
        }
      })
    }

    return {
      shipping: hasDelivery,
      payment: hasPayment
    }
  },

  stepChanger() {
    // this.el.nextButton.addEventListener('click', e => {
    //   e.preventDefault()

    //   const inputs = document.querySelectorAll('.checkout__step.active .required input[required]')
    //   const selects = document.querySelectorAll('.checkout__step.active .required select[required]')

    //   this.handleInputBlur(inputs)
    //   this.handleSelectChange(selects)

    //   if (ValidateStep(this.el.step1)) {
    //     this.el.step1.style.display = 'none'
    //     this.el.step2.style.display = 'block'
    //     this.el.prevButton.style.display = 'flex'
    //     this.el.nextButton.style.display = 'none'
    //     this.el.submitButton.style.display = 'flex'
    //   }
    // })

    // this.el.prevButton.addEventListener('click', e => {
    //   e.preventDefault()

    //   this.el.step1.style.display = 'block'
    //   this.el.step2.style.display = 'none'
    //   this.el.prevButton.style.display = 'none'
    //   this.el.nextButton.style.display = 'flex'
    //   this.el.submitButton.style.display = 'none'
    // })
  },

  handleInputBlur(items) {
    Array.prototype.forEach.call(items, (item) => {
      item.addEventListener('blur', (e) => {
        this.blurChangeHelper(item)
      })
    })
  },

  handleSelectChange(items) {
    Array.prototype.forEach.call(items, (item) => {
      item.addEventListener('change', (e) => {
        this.blurChangeHelper(item)
      })
    })
  },
  
  blurChangeHelper(item) {
    const parent = item.closest('.input-group')

    if (item.value.length > 0 && parent.classList.contains('validation--error')) {
      parent.classList.remove('validation--error')
    }
  },
}

export default Checkout
